// from https://scotch.io/tutorials/how-to-implement-a-custom-validator-directive-confirm-password-in-angular-2

import { Directive, forwardRef, Attribute, Input } from '@angular/core';
import { Validator, AbstractControl, NG_VALIDATORS } from '@angular/forms';

/*
    usage:
        add these attributes to any two formControl input field:
            <input [formControl]="password" [validateEqual]="confirmPassword" reverse="true" />
            <input [formControl]="confirmPassword" [validateEqual]="password" reverse="false" />
        you set [validateEqual] to the formControl that you want to compare to.
        the "reverse" attribute means that the other input field should show the error message,
        but we still want to check this field in case they enter the 2nd field, then go back and
        change the first one.  So in the example above, I'm showing the error message on the 2nd
        input (the confirmPassword input).
*/

@Directive({
    selector: '[validateEqual]',
    providers: [
        { provide: NG_VALIDATORS, useExisting: forwardRef(() => EqualValidator), multi: true }
    ],
    standalone: false
})
export class EqualValidator implements Validator
{
    constructor(// @Attribute('validateEqual') public validateEqual: AbstractControl,
        @Attribute('reverse') public reverse: string)
    {
    }

    @Input('validateEqual') validateEqual: AbstractControl;

    private get isReverse()
    {
        if (!this.reverse) return false;
        return this.reverse === 'true';
    }

    validate(c: AbstractControl): { [key: string]: any }
    {
        // control value
        let e = this.validateEqual;

        // value not equal
        if (e && c.value !== e.value && !this.isReverse)
        {
            return {
                validateEqual: false
            }
        }

        // value equal and reverse
        if (e && c.value === e.value && this.isReverse)
        {
            if (e.errors) {
                delete e.errors['validateEqual'];
                if (!Object.keys(e.errors).length) e.setErrors(null);
            }
        }

        // value not equal and reverse
        if (e && c.value !== e.value && this.isReverse)
        {
            e.setErrors({ validateEqual: false });
        }
        return null;
    }
}